import { render, staticRenderFns } from "./Footer_sm.vue?vue&type=template&id=9c16e27a&scoped=true&"
import script from "./Footer_sm.vue?vue&type=script&lang=js&"
export * from "./Footer_sm.vue?vue&type=script&lang=js&"
import style0 from "./Footer_sm.vue?vue&type=style&index=0&id=9c16e27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c16e27a",
  null
  
)

export default component.exports